// import ReactDOM from "react-dom/client";
// import { BrowserRouter } from "react-router-dom";
// import { base_path } from "./environment";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
// import "../src/style/css/feather.css";
// import "../src/index.scss";
// import store from "./core/data/redux/store";
// import { Provider } from "react-redux";
// import "../src/style/icon/boxicons/boxicons/css/boxicons.min.css";
// import "../src/style/icon/weather/weathericons.css";
// import "../src/style/icon/typicons/typicons.css";
// import "../node_modules/@fortawesome/fontawesome-free/css/fontawesome.min.css";
// import "../node_modules/@fortawesome/fontawesome-free/css/all.min.css";
// import "../src/style/icon/ionic/ionicons.css";
// import "../src/style/icon/tabler-icons/webfont/tabler-icons.css";
// import ALLRoutes from "./feature-module/router/router";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";
import { AuthProvider } from "./core/common/context/AuthContext";
import { ToastContainer } from "react-toastify";


import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { base_path } from "./environment";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../src/style/css/feather.css";
import "../src/index.scss";
import store from "./core/data/redux/store";
import { Provider } from "react-redux";
import "../src/style/icon/boxicons/boxicons/css/boxicons.min.css";
import "../src/style/icon/weather/weathericons.css";
import "../src/style/icon/typicons/typicons.css";
import "../node_modules/@fortawesome/fontawesome-free/css/fontawesome.min.css";
import "../node_modules/@fortawesome/fontawesome-free/css/all.min.css";
import "../src/style/icon/ionic/ionicons.css";
import "../src/style/icon/tabler-icons/webfont/tabler-icons.css";
import ALLRoutes from "./feature-module/router/router";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);



root.render(
  // <React.StrictMode>
  <AuthProvider>
    <Provider store={store}>
      <BrowserRouter basename={base_path}>
        <ALLRoutes />
      </BrowserRouter>
      {/* <ToastContainer
        position="top-right"
        autoClose={3000}
        pauseOnHover
        draggable
        theme="light"
      /> */}
<ToastContainer
  position="top-right"
  autoClose={3000}
  pauseOnHover
  draggable
  theme="light"
toastStyle={{
  backgroundColor: 'rgba(1, 77, 78, 0.2)',
  color: 'black',
  backdropFilter: 'blur(6px)', 
  fontFamily: 'Inter, Roboto, sans-serif',
  fontSize: '14px',
  fontWeight: 500,
}}

/>

    </Provider>
  </AuthProvider>
);
{/* </React.StrictMode> */ }
